import { useEffect, useState } from 'react';
import type { GQLLocale } from 'graphql-ts-types';

import { executeQuery } from 'common/gql';
import { useGQLLocale } from 'common/hooks/locale';
import type { ProductDetails, ProductsResponse } from '../components/types';
import productsQuery from '../gql/query/products.gql';

interface FetchProductsQueryArgs {
  locale: GQLLocale;
  orderId: string;
}

export const useFetchProducts = (selectedOrderId: string, setDrawerError: () => void) => {
  const locale = useGQLLocale();
  const [products, setProducts] = useState<ProductDetails[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchProducts = async (orderId: string) => {
    try {
      const { user } = await executeQuery<ProductsResponse, FetchProductsQueryArgs>({
        variables: { orderId, locale },
        query: productsQuery,
        useApq: true,
      });

      setIsLoading(false);
      setProducts(user.order.items);
    } catch {
      setIsLoading(false);
      setDrawerError();
    }
  };

  useEffect(() => {
    if (selectedOrderId) {
      fetchProducts(selectedOrderId);
    }
  }, [selectedOrderId]);

  return { products, isLoading };
};
